<template>
  <div>
    <!-- <preloader v-show="this.$store.state.preloader"></preloader> -->
    <NavHeader></NavHeader>
    <div class="wrapper row-offcanvas">
      <NavMenu class="left-side" :isFullScreen="false" key="ok" />
      <rightSide class="right-side">
        <router-view></router-view>
      </rightSide>
    </div>
  </div>
</template>

<script>
import preloader from "@/layouts/preloader/preloader";
import rightSide from "@/layouts/right-side";
import NavMenu from "@/layouts/NavMenu.vue";
import NavHeader from "@/layouts/NavHeader.vue";
import "@/../sass/custom.scss";

export default {
  name: "layout",
  components: {
    // preloader,
    NavMenu,
    NavHeader,
    rightSide,
  },
  methods: {},
  mounted() {
  },
};
</script>

<style lang="scss" scoped>
.left-side {
  position: fixed;
  top: 64px;
  left: 0;
  right: auto;
  height: calc(100% - 64px);
  overflow-y: auto;
  overflow-x: hidden;
  z-index: 1000;
  background: #ddd;

  background-repeat: repeat-y;
  box-shadow: 0 0 5px black;

}

.left-side:hover {
  width: 22rem;
}

aside.right-aside {
  display: block !important;
  width: auto !important;
}

.right-aside {
  display: table-cell;
  vertical-align: top;
}

@media screen and (max-width: 768px) {
  .left-side {
    display: none !important;
  }
}
@media screen and (min-width: 769px) {
  .right-side {
    margin-left: 64px;
  }
}

.wrapper:before,
.wrapper:after {
  display: table;
  content: " ";
}

.wrapper:after {
  clear: both;
}

.wrapper {
  display: table;
  overflow-x: hidden;
  width: 100%;
  max-width: 100%;
  table-layout: fixed;
}
</style>
